import React from 'react';
import { Link } from 'react-router-dom';

const StaticPageHeader = ({ title }) => {
    return (
        <div className="static-page-header">
            <h1 className="header-title">{title}</h1>
            <div className="static-page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="separator">/</span>
                <span>Pages</span>
                <span className="separator">/</span>
                <span>{title}</span>
            </div>
        </div>
    );
};

export default StaticPageHeader;
